export const SelectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: '12px',
    border: state.isFocused ? '1.5px solid #3e9a73' : '1.5px solid #e8eee8',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(62, 154, 115, 0.12)' : 'none',
    minHeight: '46px',
    background: '#fff',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: '#3e9a73',
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '14px',
    border: '1.5px solid #e8eee8',
    boxShadow: '0 8px 28px rgba(0,0,0,0.10)',
    zIndex: 1000,
    overflow: 'hidden',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#3e9a73'
      : state.isFocused
      ? '#f0f9f4'
      : '#fff',
    color: state.isSelected ? '#fff' : '#1a2332',
    fontWeight: state.isSelected ? '600' : '400',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: state.isSelected ? '#3e9a73' : '#f0f9f4',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#1a2332',
    fontWeight: '500',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#aab4aa',
  }),
};
